var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1721015789211,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3563,
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.6 812.8c-19.2 0-32-6.4-44.8-19.2L70.4 467.2c-25.6-25.6-25.6-64 0-89.6 25.6-25.6 64-25.6 89.6 0l281.6 281.6 441.6-428.8c25.6-25.6 64-25.6 89.6 0 25.6 25.6 25.6 64 0 89.6l-486.4 473.6C473.6 806.4 460.8 812.8 441.6 812.8z",
    fill: "#7a294f",
    "p-id": 3564
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.f6a89071e17cfd538656b38cdcf10ef9.svg";
export { ForwardRef as ReactComponent };